import { StaffMember } from '@ice-web-app/assets';
import { useTranslation } from '@ice-web-app/shared-hooks';
import { useCurrentUserStore } from '@ice-web-app/shared-store';
import { Stack } from '@mui/material';
import { Dispatch, FC, SetStateAction } from 'react';
import QuickLink from '../Links/QuickLink';
import MiniNavbarMenu from '../MiniNavbarMenu';

interface Props {
  anchorEl: HTMLElement | null;
  setAnchorEl: Dispatch<SetStateAction<HTMLElement | null>>;
  setMenu: Dispatch<SetStateAction<'ecosystem' | 'microSystem' | 'member' | 'none'>>;
}

const MemberMenu: FC<Props> = ({ anchorEl, setAnchorEl, setMenu }) => {
  const { t } = useTranslation();
  const open = Boolean(anchorEl);

  const { currentMicroSystem, currentUserType, setCurrentUserType } = useCurrentUserStore();

  return (
    <MiniNavbarMenu
      anchorEl={anchorEl}
      open={open}
      onClose={() => {
        setAnchorEl(null);
        setMenu('none');
      }}
      setAnchorEl={setAnchorEl}
    >
      <Stack direction="row" gap={1}>
        {currentMicroSystem?.userTypes.map((userType) => {
          return (
            <QuickLink
              key={userType}
              icon={<StaffMember />}
              text={t(userType)}
              width={92}
              isActive={currentUserType === userType}
              onClick={() => {
                setCurrentUserType(userType);
                setMenu('none');
              }}
            />
          );
        })}
      </Stack>
    </MiniNavbarMenu>
  );
};
export default MemberMenu;
